import { isPlainObject, snakeCase, camelCase } from 'lodash-es';

export function toCamelCase(object: unknown): unknown {
  if (Array.isArray(object)) {
    return object.map((v) => toCamelCase(v));
  } else if (isPlainObject(object)) {
    return Object.keys(object as Record<string, unknown>).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: toCamelCase((object as Record<string, unknown>)[key]),
      }),
      {},
    );
  }
  return object;
}

export function toSnakeCase(object: unknown): unknown {
  if (Array.isArray(object)) {
    return object.map((v) => toSnakeCase(v));
  } else if (isPlainObject(object)) {
    return Object.keys(object as Record<string, unknown>).reduce(
      (result, key) => ({
        ...result,
        [snakeCase(key)]: toSnakeCase((object as Record<string, unknown>)[key]),
      }),
      {},
    );
  }
  return object;
}

export function getNewIndexAfterDelete(index: number, total: number): number {
  if (index !== 0 || total === 1) {
    return index - 1;
  }
  return index;
}

export function addItemAndReorder<T extends Record<string, unknown>>(
  index: number,
  item: T,
  array: T[],
): T[] {
  return [
    ...array.slice(0, index), // unchanged
    { ...item, order: index + 1 }, // items added with order assigned
    ...array.slice(index).map((item, sliceIndex) => ({
      ...item,
      order: index + sliceIndex + 2,
    })), // items afterwards reordered
  ];
}

export function removeItemAndReorder<T extends Record<string, unknown>>(
  index: number,
  array: T[],
): T[] {
  return [
    ...array.slice(0, index), // unchanged
    ...array.slice(index + 1).map((item, sliceIndex) => ({
      ...item,
      order: index + sliceIndex + 1,
    })), // item excluded, items afterwards reordered
  ];
}

// use this for property assignments, use es6 object spread for object assignments
export function assign(target: Record<string, unknown>, data: Record<string, unknown>): void {
  Object.keys(data).forEach((key) => {
    target[key] = data[key];
  });
}

export function generateEntityCounter(counter: number = 1): number {
  return counter + 1;
}

export function convertRadianToDegree(radian: number): number {
  return (radian * 180) / Math.PI;
}

// todo: is this necessary?
export function isPositiveNumber(value: unknown): boolean {
  return Number.isFinite(value);
}

// 秒数を時分秒にする。23時間59分59秒まで対応する
export function convertSecondToDisplayTime(seconds: number): string {
  return new Date(seconds * 1000).toISOString().substr(11, 8);
}

// 0~360 => -180~180
export function convertDegreeToPositiveNegativeYaw(yaw: number): number {
  if (yaw < 180) {
    return yaw;
  } else {
    return yaw - 360;
  }
}

export function toBoolean(value: string): boolean {
  return value === 'True';
}

export function toPercentage(value: string): number {
  return parseFloat(value) * 100;
}

export function deepCopy<T>(object: T): T {
  return JSON.parse(JSON.stringify(object));
}

export function convertHexToRgba(hex: string, opacity: number = 1): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
